import { Button, notification, Select, Input, Form, InputNumber, DatePicker, Space, Modal, List, Typography, Image, Upload } from "antd"
import Title from "antd/es/typography/Title"
import {
    GetretreatByID,
    UpdateRetreat,
    GetRetreatLessons
} from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"

import { useEffect, useState } from "react"

import { ArrowLeftOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons"
import { GetDishByID, UpdateDish } from "../../../api/MonkService"
const { Link } = Typography;
const MonkDetailDish = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { id } = useParams();
    const [Edit, setEdit] = useState(false)
    const [Dish, setDish] = useState([]);

    const GetDishID = (id) => {
        console.log(id)
        GetDishByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setDish(res.data)
                form.setFieldsValue({
                    dishTypeName: res.data?.dishTypeName,
                    name: res.data?.name,
                    note: res.data?.note,
                })
            }
        })
    }



    useEffect(() => {
        GetDishID(id);
    }, []);


    const onFinish = (values) => {
        const formData = new FormData();
        formData.append('note', values.note);
        UpdateDish(id, formData)
            .then(res => {
                if (res.status === 201) {
                    notification.success({
                        message: "Update Dish Successfully"
                    });
                    setEdit(false);
                    GetDishByID(id);
                }
            })
            .catch(err => {
                console.log(err);
                notification.error({
                    message: `${err.response.data.message}`
                });
            });
    };
    return (
        <div style={{ minHeight: '96.5vh', Width: '100%' }}>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>


            <div style={{ maxWidth: 500, margin: 'auto', padding: '24' }}>

                {Edit ? (
                    <>
                        <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                            Dish
                        </Title>
                        <Form
                            onFinish={onFinish}
                            form={form}
                        >
                            <Form.Item name={"note"} label="Note" rules={[{ required: true, message: 'Requiring Note' }]}>
                                <Input
                                    placeholder="Input Note"
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button block type="primary" htmlType="submit">
                                    Confirm Update
                                </Button>
                            </Form.Item>
                        </Form>
                    </>
                ) : (
                    <>
                        <Title level={2} style={{ textAlign: 'center', marginBottom: '24' }}>
                            Retreat
                        </Title>
                        <Form form={form}>
                            <Form.Item name={"dishTypeName"} label="Dish Type Name">
                                <Input disabled
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.88)',
                                    }}
                                />
                            </Form.Item>
                            <Form.Item name={"name"} label="Name">
                                <Input disabled
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.88)',
                                    }}
                                />
                            </Form.Item>
                            <Form.Item name={"note"} label="Note">
                                <InputNumber disabled
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.88)',
                                        width: '100%'
                                    }}
                                />
                            </Form.Item>

                        </Form>
                        <div style={{ marginTop: 5, marginBottom: 16 }}>
                            <Button block type="primary" onClick={() => setEdit(true)}>
                                Update Dish
                            </Button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )

}
export default MonkDetailDish